import { z } from 'zod';
import { RoleType } from './RoleType.enum';

// Schema (source of truth)
export const userPermissionsSchema = z.object({
	roleType: z.enum(RoleType),
	permittedProfessionsIds: z.array(z.string()).optional(),
});

// Type (derived from schema)
export type IUserPermissions = z.infer<typeof userPermissionsSchema>;
